import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Confirmation = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Redirect to /editor after component mounts
        navigate('/editor');
    }, [navigate]);

    return (
        <div>
            <p>Redirecting to the editor...</p>
        </div>
    );
};

export default Confirmation;